import API from '..';
const ENTITY = 'financiers/financier-alliance-tracking';

export const getItem = (id) => API.get(`/api/v1/${ENTITY}/${id}`);
export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
export const saveItem = (data) => API.post(`/api/v1/${ENTITY}/`, data);
export const deleteItem = (id) => API.delete(`/api/v1/${ENTITY}/${id}`);
